(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/views/swipe.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/views/swipe.js'); 'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _svs$sport$result_box = svs.sport.result_boxes,
    playerForecast = _svs$sport$result_box.playerForecast,
    views = _svs$sport$result_box.views,
    graph = _svs$sport$result_box.graph,
    models = _svs$sport$result_box.models;
svs.sport.result_boxes.views.Swipe = Marionette.View.extend({
  graphView: '',
  template: function template(data) {
    return svs.sport.result_boxes.templates.ongoing_swipe(data);
  },
  log: new svs.core.log.Logger('svs.sport.result_boxes.views.Swipe'),
  useSlider: false,
  ui: {
    swipeLeft: '.swipe-arrow-left',
    swipeRight: '.swipe-arrow-right'
  },
  regions: {
    cancelled: '#swipe-cancelled',
    gamestart: '#swipe-gamestart',
    result: '#swipe-result',
    history: '#swipe-history',
    correctRows: '#correct-rows',
    distribution: '#distribution'
  },
  initialize: function initialize() {
    this.currentSlideId = this.model.get('currentSlideId').id;
    this.addSwiperRegions();
    var self = this;
    this.model.on('change:startGame', function () {
      self.addSwiperRegions();
      self.render();
      self.onAttach();
    });
    this.model.get('forecast').on('gotMultiForecast', function () {
      self.addSwiperRegions();
      self.render();
      self.onAttach();
    });
    this.model.on('change:payouts', function () {
      self.addSwiperRegions();
      self.render();
      self.onAttach();
    });
  },
  onRender: function onRender() {
    this.showSwiperViews();
  },
  onAttach: function onAttach() {
    if (this.useSlider) {
      var rsContainer = $('.royalSlider');
      rsContainer.royalSlider({
        autoHeight: true,
        arrowsNav: false,
        controlsInside: false,
        controlNavigationSpacing: 0,
        controlNavigation: 'bullets',
        loop: false,
        loopRewind: false,
        fadeinLoadedSlide: false,
        startSlideId: this.currentSlideId
      });
      this.ui.swipeRight.removeClass('hide-arrow');
      this.slider = rsContainer.data('royalSlider');
      var self = this;
      this.ui.swipeLeft.click(function () {
        self.slider.prev();
      });
      this.ui.swipeRight.click(function () {
        self.slider.next();
      });
      this.slider.ev.on('rsAfterSlideChange', function (event) {
        if (event.target.currSlideId === 0) {
          self.ui.swipeLeft.addClass('hide-arrow');
          self.ui.swipeRight.removeClass('hide-arrow');
        } else if (event.target.currSlideId === self.slider.numSlides - 1) {
          self.ui.swipeLeft.removeClass('hide-arrow');
          self.ui.swipeRight.addClass('hide-arrow');
        } else {
          self.ui.swipeLeft.removeClass('hide-arrow');
          self.ui.swipeRight.removeClass('hide-arrow');
        }
      }); 

      setTimeout(function () {
        rsContainer.resize();
      }, 1000);
    }
  },
  showSwiperViews: function showSwiperViews() {
    if (_typeof(this.model.get('refunds')) === 'object' && this.model.get('refunds') !== null) {
      this.showChildView('cancelled', new views.SwipeCancelled({
        model: this.model
      }));
    } else if (this.model.hasNotStarted()) {
      this.showChildView('gamestart', new views.SwipeGameStart({
        model: this.model
      }));
    } else if (this.model.hasFinishedOrRunning()) {
      if (this.useSlider) {
        if (this.model.get('playerForecasts')) {
          if (this.model.get('playerForecasts')) {
            this.showChildView('history', new views.SwipeHistory({
              model: new graph.GraphModel({
                playerForecasts: this.model.get('playerForecasts'),
                numOfMatches: this.model.get('numOfMatches'),
                cancelCloseTime: this.model.get('cancelCloseTime')
              })
            }));
          }
        }

        if (this.model.get('forecast').get('formattedMultiforecast') && svs.core.detect.feature('ft-trotting-forecast')) {
          var self = this;
          this.showChildView('distribution', new views.FinalDistribution({
            model: new Backbone.Model({
              multiForecast: this.model.get('forecast').get('formattedMultiforecast'),
              teamText: this.model.get('draw').get('drawEvents').find(function (drawEvent) {
                return drawEvent.eventNumber === self.model.get('forecast').get('multiForecast')[0].eventNumber;
              }).eventDescription
            })
          }));
        } else {
          this.showChildView('distribution', new views.SwipeDistribution({
            model: new models.Distribution({
              payouts: this.model.get('payouts'),
              drawStateId: this.model.get('drawStateId'),
              productName: this.model.get('productName'),
              currentNetSale: this.model.get('currentNetSale')
            })
          }));
        }
      }

      this.showChildView('result', new views.SwipeForecastResult({
        model: new models.ForecastResult({
          winAmount: this.model.get('winAmount'),
          numCorrect: this.model.get('numCorrect'),
          hasWon: this.model.get('hasWon'),
          drawNumber: this.model.get('drawNumber'),
          isFinished: this.model.isFinished(),
          productName: this.model.get('productName'),
          wins: this.model.get('wins'),
          model: this.model
        })
      }));

      if (this.model.get('correctRowModel')) {
        this.showChildView('correctRows', new views.MyBetCorrectRow({
          model: this.model.get('correctRowModel')
        }));
      }
    }
  },
  addSwiperRegions: function addSwiperRegions() {
    this.model.set('regions', []);
    this.model.set('views', []);
    this.removeRegions();
    var tabs;
    var regions = [];

    if (_typeof(this.model.get('refunds')) === 'object' && this.model.get('refunds') !== null) {
      regions.push('swipe-cancelled');
      tabs = {
        cancelled: '#swipe-cancelled'
      };
      this.useSlider = false;
    } else if (this.model.hasNotStarted()) {
      regions.push('swipe-gamestart');
      tabs = {
        gamestart: '#swipe-gamestart'
      };
      this.useSlider = false;
    } else if (this.model.hasFinishedOrRunning()) {
      regions.push('swipe-result');

      if (this.model.get('playerForecasts')) {
        regions.push('distribution');
        regions.push('swipe-history');
        tabs = {
          history: '#swipe-history',
          result: '#swipe-result',
          distribution: '#distribution'
        };
        this.useSlider = true;
      } else if (this.model.get('forecast')) {
        regions.push('distribution');
        tabs = {
          result: '#swipe-result',
          distribution: '#distribution'
        };
        this.useSlider = true;
      } else {
        tabs = {
          result: '#swipe-result'
        };
        this.useSlider = true;
      }

      if (this.model.get('correctRowModel')) {
        tabs.correctRows = '#correct-rows';
      }

      if (this.model.get('correctRowModel')) {
        regions.push('correct-rows');
      }
    }

    this.addRegions(tabs);
    this.model.set('views', tabs);
    this.model.set('regions', regions);
    this.model.set('useSlider', this.useSlider);
  }
});
svs.sport.result_boxes.views.SwipeCancelled = Backbone.Marionette.View.extend({
  template: function template(data) {
    return svs.sport.result_boxes.templates.ongoing_swipe_cancelled(data);
  },
  className: 'swipe-item'
});
svs.sport.result_boxes.views.SwipeGameStart = Backbone.Marionette.View.extend({
  template: function template(data) {
    return svs.sport.result_boxes.templates.ongoing_swipe_gamestart(data);
  },
  ui: {
    swipeContainer: '#swipe-item-start'
  },
  initialize: function initialize() {
    this.listenTo(this.model, 'change:cancelCloseTime', this.render);
  }
});
svs.sport.result_boxes.views.SwipeCountdown = Backbone.Marionette.View.extend({
  template: function template(data) {
    return svs.sport.result_boxes.templates.ongoing_swipe_countdown(data);
  },
  className: 'matchstart-time'
});
svs.sport.result_boxes.views.SwipeHistory = Marionette.View.extend({
  regions: {
    graph: '#resultGraph'
  },
  playerForecasts: null,
  className: 'padding-xs-h-2 trend-graph-container',
  template: function template(data) {
    return svs.sport.result_boxes.templates.ongoing_swipe_history(data);
  },
  initialize: function initialize() {
    if (this.model.get('playerForecasts') && this.model.get('playerForecasts').isSynced) {
      this.createGraphView();
      this.listenTo(this.model.get('playerForecasts'), 'add', this.resultChanged);
    } else if (this.model.get('playerForecasts')) {
      this.listenToOnce(this.model.get('playerForecasts'), 'sync', this.playerForecastSynced);
    }
  },
  createGraphView: function createGraphView() {
    this.playerForecasts = playerForecast(this.model.get('playerForecasts'));
    var points = this.playerForecasts.getPoints(),
        datePoints = this.playerForecasts.getDatePoints(this.model.get('cancelCloseTime'));
    var graphPoints = new graph.GraphPoints({
      showEndWedge: this.model.get('isFinalized'),
      numberOfMatches: this.model.get('numOfMatches'),
      points: points,
      datePoints: datePoints
    });
    this.graphView = new graph.GraphView({
      model: graphPoints
    });
  },
  playerForecastSynced: function playerForecastSynced() {
    this.createGraphView();

    if (this.loader) {
      this.loader.hide(true);
    }

    if (this.model.get('playerForecasts')) {
      this.listenTo(this.model.get('playerForecasts'), 'add', this.resultChanged);
    }

    this.showChildView('graph', this.graphView);
  },
  resultChanged: function resultChanged() {
    if (this.graphView && this.model.get('playerForecasts')) {
      this.playerForecasts.setPlayerResults(this.model.get('playerForecasts'));
      this.graphView.clear();
      this.graphView.addPoints(this.playerForecasts.getPoints());
    }
  },
  onDomRefresh: function onDomRefresh() {
    if (!this.graphView) {
      this.loader = new svs.components.Loader(this.getRegion('graph').el);
      this.loader.show(200);
    } else {
      this.showChildView('graph', this.graphView);
    }
  }
});
svs.sport.result_boxes.views.SwipeDistribution = Marionette.View.extend({
  template: function template(data) {
    return svs.sport.result_boxes.templates.distribution(data);
  }
});
 })(window);